import type { ReactNode } from 'react';
import { Desktop } from '../desktop/Desktop';

/** OS web shell = the desktop (menu bar, launcher stage, dock, Start menu). See src/desktop/. */
export function Shell({ children }: { children: ReactNode }) {
  return <Desktop>{children}</Desktop>;
}
